var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-map-container" },
    [
      _c("div", { attrs: { id: "main-map" } }),
      _vm._v(" "),
      _c("div", { staticClass: "map-controls" }, [
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
        _vm._v(" "),
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "mobile-logos-in-map-controls" }, [
          _c("a", { attrs: { href: "https://mcsuk.org" } }, [
            _c(
              "svg",
              { attrs: { "aria-hidden": "true", focusable: "false" } },
              [_c("use", { attrs: { href: "#mcs-logo" } })]
            ),
          ]),
          _vm._v(" "),
          _vm._m(4),
          _vm._v(" "),
          _vm._m(5),
        ]),
      ]),
      _vm._v(" "),
      _vm.showLoadingOverlay
        ? _c("div", { staticClass: "main-map-overlay" }, [
            _c("div", [
              _c("h4", [_vm._v(_vm._s(_vm.loadingOverlayText))]),
              _vm._v(" "),
              _vm._m(6),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showDetailsModal
        ? _c(
            "modal",
            {
              attrs: { size: "medium", "vertical-position": "top" },
              on: {
                close: function ($event) {
                  _vm.showDetailsModal = false
                  _vm.showConditionDetails = false
                  _vm.detailsTitle = ""
                  _vm.detailsContent = ""
                  _vm.detailsShowChart = false
                },
              },
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("h3", [_vm._v(_vm._s(_vm.detailsTitle))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "details-content",
                  attrs: { slot: "body" },
                  slot: "body",
                },
                [
                  !_vm.showConditionDetails
                    ? _c("div", [
                        _c("div", {
                          domProps: { innerHTML: _vm._s(_vm.detailsContent) },
                        }),
                        _vm._v(" "),
                        _c("div", {
                          staticStyle: { cursor: "pointer" },
                          domProps: { innerHTML: _vm._s(_vm.conditionLeader) },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.showConditionDetails = true
                            },
                          },
                        }),
                        _vm._v(" "),
                        !_vm.is_byelaw
                          ? _c("div", [
                              _c("hr"),
                              _vm._v(" "),
                              _vm.detailsShowChart
                                ? _c("div", {
                                    staticClass: "popupFishingDataChart",
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.detailsShowChart
                                ? _c("div", [
                                    _vm._v("No fishing data available."),
                                  ])
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showConditionDetails
                    ? _c(
                        "div",
                        [
                          _c("div", {
                            domProps: {
                              innerHTML: _vm._s(_vm.conditionReport),
                            },
                          }),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c("feature-tabs", {
                            attrs: { features: _vm.conditionFeatures },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", [
      _c("button", { staticClass: "rc-menu-button active" }, [_vm._v("Map")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "/stats/" } }, [
      _c("button", { staticClass: "rc-menu-button" }, [_vm._v("Statistics")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "/history/" } }, [
      _c("button", { staticClass: "rc-menu-button" }, [_vm._v("History")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("a", { attrs: { href: "/info/" } }, [
      _c("button", { staticClass: "rc-menu-button" }, [_vm._v("Information")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { attrs: { target: "_blank", href: "https://www.wildlifetrusts.org/" } },
      [
        _c("img", {
          attrs: {
            src: "/static/img/TWT_LOGO_PRIMARY_COLOUR.SVG.svg",
            alt: "The Wildlife Trusts",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      {
        attrs: {
          target: "_blank",
          href: "https://www.bluemarinefoundation.com",
        },
      },
      [
        _c("img", {
          attrs: {
            src: "/static/img/BMF_Logo_CMYK_Blue.svg",
            alt: "Blue Marine Foundation",
          },
        }),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "overlay-spinner" }, [
      _c("div", { staticClass: "s-r1" }),
      _c("div", { staticClass: "s-r2" }),
      _c("div", { staticClass: "s-r3" }),
      _c("div", { staticClass: "s-r4" }),
      _c("div", { staticClass: "s-r5" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }